<template>
  <v-card>
    <v-card-title class="px-6 py-4 d-flex align-center">
      <v-skeleton-loader type="text" width="500" />
    </v-card-title>
    <v-divider />
    <div class="breakdown-items align-center px-6 py-4">
      <div v-for="i in 3" :key="i" class="breakdown-item">
        <v-skeleton-loader type="text" width="200" />
        <v-skeleton-loader class="value-loader" type="text" />
      </div>
    </div>
    <v-divider />
    <v-card-actions
      class="d-flex justify-end grey lighten-5 py-4 px-6"
    >
      <v-skeleton-loader type="button" class="mr-2" />
      <v-skeleton-loader type="button" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'RevisionCardSkeletonLoader',
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.breakdown-items {
  display: grid;
  grid-template-columns: 220px 250px 1fr;
  & .breakdown-item {
    @extend .mr-4;
  }
}
</style>
